/** @format */
import { inject, Injectable } from '@angular/core';
import { ValidatablePlan } from 'common-typescript';
import { Observable, of, shareReplay, switchMap } from 'rxjs';
import { PlanLoaderService } from '../../common/service/plan-loader.service';
import { SelectedPlanService } from './selected-plan.service';

/**
 * Analogous to {@link SelectedPlanService}, but provides a {@link ValidatablePlan} that is built based on
 * the selected plan. Emits a recreated `ValidatablePlan` whenever changes are made to the underlying plan,
 * and null when there is no selected plan.
 */
@Injectable()
export class SelectedValidatablePlanService {
    private readonly planLoader = inject(PlanLoaderService);
    private readonly selectedPlanService = inject(SelectedPlanService);

    readonly selectedValidatablePlan$: Observable<ValidatablePlan | null> = this.selectedPlanService.selectedPlan$.pipe(
        switchMap(plan => (plan ? this.planLoader.createValidatablePlan(plan) : of(null))),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
}
